import * as LayoutCreatorEntities from '@bimser/components/dist/BCLayoutCreator/common/entities';
import { FormItemTypes } from '@bimser/core';
import { Map } from 'immutable';
import { evaluateIt } from '.';
import { IDataGridRowCollection } from '../../../environments/runtime/components/DataGrid/entities';

export function formulaEvaluate(
	formula: string,
	oldFormData: Map<string, LayoutCreatorEntities.LayoutItem>
): any {
	if (formula) {
		const controlRegex = /\[([\s\S]*?)\]/gm;
		const match = formula.match(controlRegex);

		if (match) {
			match.forEach(source => {
				const rawPath = source.replace('[', '').replace(']', '').split('.');
				const sourceId = rawPath[0];
				const sourcePropPath = rawPath.slice(1, rawPath.length);

				let v: any;

				const sourceItem = oldFormData.get(sourceId);
				const controlType = sourceItem.properties.get('controlType');
				let valueOverridden = false;

				if (controlType === FormItemTypes.EControlTypes.DataGrid) {
					if (sourcePropPath.indexOf('columns') === 0) {
						const rows: IDataGridRowCollection = sourceItem.properties.get('rows');
						const columnName = sourcePropPath.pop();

						const values = rows.map(row => row.data[columnName]);
						v = values && values.length ? values.join(',') : '0';

						valueOverridden = true;
					}
				}

				if (!valueOverridden) {
					v = sourceItem.properties.getIn(sourcePropPath);

					if (Number.isNaN(v) || v === null) {
						v = 0;
					}

					if (typeof v === 'string') {
						v = `'${v}'`;
					}
					if (typeof v === 'undefined') {
						v = '0';
					}
				}

				formula = formula.replace(source, v);
			});
		}

		const result = evaluateIt(formula);

		if (!Number.isNaN(result)) {
			return result;
		} else {
			return 0;
		}
	}

	return formula;
}
